import { useQueryDataTableFilter } from '~/shared/data-tables/query/useQueryDataTableFilter';
import { DebounceTextField } from '~/shared/forms/controls/base-fields/DebounceTextField';
import { DatePickerField } from '~/shared/forms/controls/base-fields/DatePickerField';
import { AutocompleteSearchField } from '~/shared/forms/controls/base-fields/AutocompleteSearchField';
import { CheckboxField } from '~/shared/forms/controls/base-fields/CheckboxField';
import { convertUrlDateToClientDate } from '~/util/date';

export function DaysRemainingFromFilter() {
	const [daysRemainingFrom, setDaysRemainingFrom] = useQueryDataTableFilter({
		name: 'daysRemainingFrom',
		convertFromQueryParam: value => value,
		operator: '>='
	});
	return (
		<DebounceTextField
			className="w-[100px]"
			label="Days Remaining From"
			hideLabel
			type="number"
			value={daysRemainingFrom}
			onChange={setDaysRemainingFrom}
		/>
	);
}

export function DaysRemainingToFilter() {
	const [daysRemainingTo, setDaysRemainingTo] = useQueryDataTableFilter({
		name: 'daysRemainingTo',
		convertFromQueryParam: value => value,
		operator: '<='
	});
	return (
		<DebounceTextField
			className="w-[100px]"
			label="Days Remaining To"
			hideLabel
			type="number"
			value={daysRemainingTo}
			onChange={setDaysRemainingTo}
		/>
	);
}

export function VisitTotalFromFilter() {
	const [visitTotalFrom, setVisitTotalFrom] = useQueryDataTableFilter({
		name: 'visitTotalFrom',
		convertFromQueryParam: value => value,
		operator: '>='
	});
	return (
		<DebounceTextField
			className="w-[100px]"
			label="Visit Total From"
			hideLabel
			type="number"
			value={visitTotalFrom}
			onChange={setVisitTotalFrom}
		/>
	);
}

export function VisitTotalToFilter() {
	const [visitTotalTo, setVisitTotalTo] = useQueryDataTableFilter({
		name: 'visitTotalTo',
		convertFromQueryParam: value => value,
		operator: '<='
	});
	return <DebounceTextField className="w-[100px]" label="Visit Total To" hideLabel type="number" value={visitTotalTo} onChange={setVisitTotalTo} />;
}

export function EpisodeInsuranceFilter() {
	const [primaryInsurance, setPrimaryInsurance] = useQueryDataTableFilter({
		name: 'primaryInsurance',
		convertFromQueryParam: value => value,
		operator: '=='
	});
	return (
		<AutocompleteSearchField
			label="Insurance"
			hideLabel
			placeholder="All Insurances"
			searchType="schedule-report-primary-insurance"
			value={primaryInsurance}
			onChange={id => setPrimaryInsurance(id)}
		/>
	);
}

export function StartDateFromFilter() {
	const [startDateFrom, setStartDateFrom] = useQueryDataTableFilter({
		name: 'startDateFrom',
		convertFromQueryParam: value => convertUrlDateToClientDate(value),
		operator: '>='
	});
	return <DatePickerField label="Start Date From" hideLabel required value={startDateFrom} onChange={setStartDateFrom} />;
}

export function StartDateToFilter() {
	const [startDateTo, setStartDateTo] = useQueryDataTableFilter({
		name: 'startDateTo',
		convertFromQueryParam: value => convertUrlDateToClientDate(value),
		operator: '<='
	});
	return <DatePickerField label="Start Date To" hideLabel required value={startDateTo} onChange={setStartDateTo} />;
}

export function CurrentPeriodonly() {
	const [currentPeriodOnly, setCurrentPeriodOnly] = useQueryDataTableFilter<boolean>({
		name: 'isCurrentPeriod',
		convertFromQueryParam: value => value === 'true',
		operator: '=='
	});
	return <CheckboxField label="Current Period Only" hideLabel value={currentPeriodOnly} onChange={setCurrentPeriodOnly} />;
}
